<template>
  <div>
    <navigation />
    <div class="p-grid backorder-table">
      <div class="p-sm-12">
        <TabView class="tab-container">
          <TabPanel header="Backorders List">
            <div class="p-grid">
              <div class="p-sm-12">
                <DataTable
                  class="p-datatable-responsive-demo"
                  :v-if="isLoaded"
                  :value="customers"
                  :paginator="true"
                  :rows="10"
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 30]"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  :selection.sync="selectRows"
                  dataKey="id"
                  :scrollable="true"
                  :resizableColumns="true"
                  columnResizeMode="expand"
                  :filters="backOrderedFilters"
                >
                  <template #header>
                    <div>
                      <div class="p-grid p-ai-center vertical-container">
                        <div class="p-sm-4">Backorders List</div>
                        <div class="p-sm-offset-5 p-sm-3">
                          <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText
                              placeholder="Global Search"
                              v-model="backOrderedFilters['global']"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <Column
                    selectionMode="multiple"
                    headerStyle="width: 3em"
                  ></Column>

                  <Column
                    field="order_name"
                    header="Order Name"
                    sortable
                    headerStyle="width: 100px"
                  ></Column>
                  <Column
                    field="createdAt"
                    header="Ordered Date"
                    sortable
                    headerStyle="width: 150px"
                  >
                    <template #filter>
                      <InputText
                        type="text"
                        v-model="backOrderedFilters['createdAt']"
                        class="p-column-filter"
                        placeholder="Backorder Date"
                      />
                    </template>
                  </Column>
                  <Column
                    field="order_id"
                    header="Order Id"
                    sortable
                    headerStyle="width: 200px"
                  ></Column>
                  <Column
                    field="sku"
                    header="SKU"
                    sortable
                    headerStyle="width: 250px"
                  >
                    <template #filter>
                      <InputText
                        type="text"
                        v-model="backOrderedFilters['sku']"
                        class="p-column-filter"
                        placeholder="SKU Number"
                      />
                    </template>
                  </Column>
                  <Column
                    field="customer_email"
                    header="Email"
                    sortable
                    headerStyle="width: 200px"
                  ></Column>
                  <Column
                    field="ops_approved"
                    header="OPS Approved"
                    sortable
                    headerStyle="width: 150px"
                  >
                    <template #filter>
                      <InputText
                        type="text"
                        v-model="backOrderedFilters['ops_approved']"
                        class="p-column-filter"
                        placeholder="true/false"
                      />
                    </template>
                  </Column>
                  <Column
                    field="cx_approved"
                    header="CX Approved"
                    sortable
                    headerStyle="width: 250px"
                  >
                    <template #filter>
                      <InputText
                        type="text"
                        v-model="backOrderedFilters['cx_approved']"
                        class="p-column-filter"
                        placeholder="true/false"
                      />
                    </template>
                  </Column>
                  <Column
                    field="qty_backordered"
                    header="QTY Backordered"
                    sortable
                    headerStyle="width: 250px"
                  ></Column>
                  <Column
                    field="qty_ordered"
                    header="QTY Ordered"
                    sortable
                    headerStyle="width: 250px"
                  ></Column>
                </DataTable>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-sm-offset-10 p-sm-2" v-if="this.isUserOpsTeam()">
                <button
                  class="button"
                  @click="onOpsAprroved"
                  :disabled="isOpsDisabled"
                >
                  Ops Approve
                </button>
              </div>
              <div class="p-sm-offset-10 p-sm-2" v-if="this.isUserCxTeam()">
                <button
                  class="button"
                  :disabled="isCxDisabled"
                  @click="onCxAprroved"
                >
                  CX Approve
                </button>
              </div>
            </div>
            <div class="p-grid" v-if="this.isUserRoleAdmin()">
              <div class="p-sm-offset-8 p-sm-2">
                <button
                  class="button"
                  @click="onOpsAprroved"
                  :disabled="isOpsDisabled"
                >
                  Ops Approve
                </button>
              </div>
              <div class="p-sm-2">
                <button
                  class="button"
                  :disabled="isCxDisabled"
                  @click="onCxAprroved"
                >
                  CX Approve
                </button>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Approved Backorders List">
            <div class="p-grid">
              <div class="p-sm-12">
                <DataTable
                  :value="approvedCustomers"
                  :paginator="true"
                  :rows="10"
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  :rowsPerPageOptions="[10, 20, 30]"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  :filters="opsFilters"
                  :resizableColumns="true"
                  columnResizeMode="expand"
                  :scrollable="true"
                >
                  <template #header>
                    <div>
                      <div class="p-grid p-ai-center vertical-container">
                        <div class="p-sm-2">Approved Backorders List</div>
                        <div class="p-sm-offset-8 p-sm-2">
                          <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText
                              placeholder="Global Search"
                              v-model="opsFilters['global']"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <Column
                    field="order_name"
                    header="Order Name"
                    headerStyle="width: 100px"
                  ></Column>
                  <Column
                    field="order_id"
                    header="Order Id"
                    headerStyle="width: 150px"
                  ></Column>
                  <Column
                    field="createdAt"
                    header="Ordered Date"
                    sortable
                    headerStyle="width: 150px"
                  >
                    <template #filter>
                      <InputText
                        type="text"
                        v-model="opsFilters['createdAt']"
                        class="p-column-filter"
                        placeholder="Backorder Date"
                      />
                    </template>
                  </Column>
                  <Column field="sku" header="SKU" headerStyle="width: 200px">
                    <template #filter>
                      <InputText
                        type="text"
                        v-model="opsFilters['sku']"
                        class="p-column-filter"
                        placeholder="SKU Number"
                      />
                    </template>
                  </Column>
                  <Column
                    field="customer_email"
                    header="Email"
                    headerStyle="width: 250px"
                  ></Column>
                  <Column
                    field="ops_approved"
                    header="Ops Approved"
                    headerStyle="width: 150px"
                  >
                    <template #filter>
                      <InputText
                        type="text"
                        v-model="opsFilters['ops_approved']"
                        class="p-column-filter"
                        placeholder="true/false"
                      />
                    </template>
                  </Column>
                  <Column
                    field="cx_approved"
                    header="Cx Approved"
                    headerStyle="width: 150px"
                  >
                    <template #filter>
                      <InputText
                        type="text"
                        v-model="opsFilters['cx_approved']"
                        class="p-column-filter"
                        placeholder="true/false"
                      />
                    </template>
                  </Column>
                  <Column
                    field="qty_backordered"
                    header="QTY Backorder"
                    headerStyle="width: 150px"
                  ></Column>
                  <Column
                    field="qty_ordered"
                    header="QTY Ordered"
                    headerStyle="width: 150px"
                  ></Column>
                </DataTable>
              </div>
            </div>
          </TabPanel>
        </TabView>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import "primeflex/primeflex.css";
import swal from "sweetalert";
import http from "../../http-common";
import navigation from "../helperComponents/menu.vue";
import { convertISODate, convertDateFormat } from "../../scripts/utility";

export default {
  name: "backorderCustList",
  components: {
    DataTable,
    Column,
    navigation,
    InputText,
    TabView,
    TabPanel,
  },
  data() {
    return {
      customers: [],
      approvedCustomers: [],
      selectRows: null,
      isLoaded: false,
      customerID: [],
      backOrderedFilters: {},
      opsFilters: {},
      userInfo: {},
      isCxDisabled: true,
      isOpsDisabled: true,
      apiUrlPath: "api/backorders",
    };
  },
  methods: {
    /* eslint-disable no-console */
    isUserOpsTeam() {
      if (this.userInfo.team == "OPs Team") {
        return true;
      } else {
        return false;
      }
    },
    isUserCxTeam() {
      if (this.userInfo.team == "CX Team") {
        return true;
      } else {
        return false;
      }
    },
    isUserRoleAdmin() {
      if (this.userInfo.role == "Admin") {
        return true;
      } else {
        return false;
      }
    },
    retrieveCustomers() {
      http
        .get(`${this.apiUrlPath}/all-customers`)
        .then((response) => {
          const resDate = response.data;
          resDate.forEach((element) => {
            element.createdAt = convertISODate(element.createdAt);
          });
          this.customers = response.data;
          this.isLoaded = true;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    retrieveApprovedCustomers() {
      http
        .get(`${this.apiUrlPath}/all-approved-customers`)
        .then((response) => {
          const resDate = response.data;
          resDate.forEach((element) => {
            element.createdAt = convertDateFormat(element.createdAt);
          });
          this.approvedCustomers = response.data;
          this.isLoaded = true;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    onOpsAprroved(e) {
      this.isCxDisabled = false;
      let customerId = this.customerID;
      http.put(`${this.apiUrlPath}/ops-approved/${customerId}`).then((res) => {
        if (res.status === 200) {
          swal("Ops Approved", "", "success");
          this.retrieveCustomers();
          this.selectRows = [];
        } else {
          swal("Could Not Ops Approved", "", "error");
        }
      });
    },
    onCxAprroved(e) {
      e.preventDefault();
      let customerId = this.customerID;
      http.put(`${this.apiUrlPath}/cx-approved/${customerId}`).then((res) => {
        if (res.status === 200) {
          swal("CX Approved", "", "success");
          this.retrieveCustomers();
          this.retrieveApprovedCustomers();
          this.selectRows = [];
        } else {
          swal("Could Not CX Approve", "", "error");
        }
      });
    },
    /* eslint-enable no-console */
  },
  watch: {
    selectRows: function (e) {
      if (this.selectRows.length === 0) {
        this.isCxDisabled = true;
        this.isOpsDisabled = true;
      }
      let arr = {};
      arr = this.selectRows;
      let selectedOpsArray = arr.map((e) => e.ops_approved);
      let selectedIdArray = arr.map((e) => e.id);
      let checker = (arr) => arr.every((v) => v === "true");
      let selectedOptions = checker(selectedOpsArray);

      if (this.selectRows.length >= 1 && selectedOptions === true) {
        this.customerID = [];
        this.isCxDisabled = false;
        this.isOpsDisabled = true;
        this.customerID.push(...selectedIdArray);
      }
      if (this.selectRows.length >= 1 && selectedOptions === false) {
        this.customerID = [];
        this.isCxDisabled = true;
        this.isOpsDisabled = false;
        this.customerID.push(...selectedIdArray);
      }
    },
  },
  created() {
    this.retrieveCustomers();
    this.retrieveApprovedCustomers();
  },
  mounted() {
    if (sessionStorage.getItem("User Information")) {
      this.userInfo = JSON.parse(sessionStorage.getItem("User Information"));
    }
  },
};
</script>

<style>
.tab-container {
  margin-top: 15px;
}

.p-error, .p-invalid {
  color: #e7a3a3;
}

.datatable-container {
  margin-top: 15px;
}

.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link,
.p-datatable .p-paginator-bottom {
  background: #00424a !important;
  color: #fff !important;
}

.p-tabview .p-tabview-nav li .p-tabview-nav-link,
.p-datatable .p-datatable-header {
  background: #fff !important;
  color: #00424a !important;
}

.p-datatable .p-datatable-thead > tr > th {
  background-color: #00424a !important;
  color: #fff !important;
  border: 1px solid #000 !important;
  font-size: 14px;
  font-weight: normal !important;
}

.p-datatable-scrollable-body > table > .p-datatable-tbody > tr > td,
.p-datatable .p-datatable-tbody > tr > td {
  color: #4d4d4d;
  font-size: 14px;
}

.p-paginator .p-paginator-current {
  color: #fff !important;
  font-size: 16px;
  font-weight: normal;
}

.p-paginator .p-paginator-first,
.p-paginator .p-paginator-prev,
.p-paginator .p-paginator-next,
.p-paginator .p-paginator-last,
.p-paginator .p-paginator-pages .p-paginator-page,
.p-sortable-column-icon {
  color: #fff !important;
}

.p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
  background: #fff !important;
  border-color: #fff !important;
  color: #4d4d4d !important;
}

.p-paginator .p-paginator-first:not(.p-disabled):not(.p-highlight):hover,
.p-paginator .p-paginator-prev:not(.p-disabled):not(.p-highlight):hover,
.p-paginator .p-paginator-next:not(.p-disabled):not(.p-highlight):hover,
.p-paginator .p-paginator-last:not(.p-disabled):not(.p-highlight):hover,
.p-paginator .p-paginator-pages .p-paginator-page:not(.p-highlight):hover {
  color: #4d4d4d !important;
}

.p-inputtext {
  width: 100%;
  border: 1px solid #4d4d4d !important;
  color: #4d4d4d !important;
}

.p-menubar
  .p-menubar-root-list
  > .p-menuitem
  > .p-menuitem-link
  .p-menuitem-text,
.p-menubar
  .p-menubar-root-list
  > .p-menuitem
  > .p-menuitem-link
  .p-menuitem-icon {
  color: #00424a !important;
}

.router-link-exact-active {
  background: #eaeaea;
}

.backorder-table .p-tabview-panel {
  overflow-x: hidden;
}
</style>
